import { createAction, props } from '@ngrx/store';

export const updateApplicantsIsLoadingFromApplicantsSavingData = createAction(
  '[ApplicantSavingData] Update Applicants Is Loading',
  props<{ isLoading: boolean }>()
);